/* tslint:disable */
import * as React from "react";

const SvgIconMicrophone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg id="icon-microphone_svg__working" viewBox="0 0 52.88 100" {...props}>
    <defs>
      <style>{".icon-microphone_svg__cls-1{fill:#fff}"}</style>
    </defs>
    <g id="icon-microphone_svg__audio_controls" data-name="audio controls">
      <path
        className="icon-microphone_svg__cls-1"
        d="M26.44 69.23a15.43 15.43 0 0 0 15.39-15.38V15.38a15.39 15.39 0 0 0-30.77 0v38.47a15.42 15.42 0 0 0 15.38 15.38z"
      />
      <path
        className="icon-microphone_svg__cls-1"
        d="M49.52 34.62A3.38 3.38 0 0 0 46.15 38v16.57a19.71 19.71 0 0 1-39.42 0V38A3.37 3.37 0 0 0 0 38v16.57a26.47 26.47 0 0 0 23.08 26.22v12.48h-8.66a3.37 3.37 0 0 0 0 6.73h24a3.37 3.37 0 1 0 0-6.73h-8.61V80.79a26.47 26.47 0 0 0 23.07-26.22V38a3.37 3.37 0 0 0-3.36-3.38z"
      />
    </g>
  </svg>
);

export default SvgIconMicrophone;

